<template lang="pug">
	.navbar-item.navbar-show-on-top
		.buttons
			a.button.is-primary.is-enel.button-height-navbar(@click="goPromoCode")
				div
					| {{ $t("menu.promo_code_short") }}
					.navbar-partner-logo
						img(src="/img/enel_logo.png")
					| {{ $t("button.click_here") }}
</template>

<script>
export default {
	methods: {
		goPromoCode() {
			this.$router.push('/promo-code')
		}
	}
}
</script>
